import * as React from 'react';

const BgWireframePattern = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 361 201"
    fill="none">
    <mask
      id="a"
      width={361}
      height={201}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#2961FA"
        d="M354.747.8h-348a6 6 0 0 0-6 6v188.001a6 6 0 0 0 6 6h348a6 6 0 0 0 6-6v-188a6 6 0 0 0-6-6Z"
      />
    </mask>
    <g stroke="#fff" strokeWidth={0.356} mask="url(#a)" opacity={0.3}>
      <path d="m322.346 19.095 103.193 12.439m-42.355 241.4-75.469-55.759-81.245-30.023-81.245-47.571-103.578 23.785m0 0 98.187 64.337-64.88 45.036-33.307-109.373Zm0 0-91.256-41.331L65.52 78.753 14.309 19.095l60.645-58.293L-.323-94.762" />
      <path d="M14.307 19.094 117.499 31.57l58.913 47.18 82.015 43.282-113.397 17.352-79.705-60.828M168.711 282.68l-28.879-54.979" />
      <path d="m226.471 187.151 22.332 70.966 58.913-40.942 41.97-53.809-91.256-41.332-31.959 65.117Zm0 0-86.636 40.552 5.391-88.122 31.189-60.828 57.372-44.061 88.561-15.597-73.737-73.11-79.897 24.76-28.879-54.98-64.88 45.037 42.547 70.77-51.981 47.18-23.873 84.614-41.97 53.809 75.469 55.759" />
      <path d="m226.469-124.781 22.526 71.16 58.719-41.136m-49.286 216.796-24.643-87.342m0 0-116.284-3.12 51.211-60.828m65.073 63.948 139.773 44.06m-197.145 0H65.519" />
      <path d="M-59.236-53.82 74.953-39.196l93.759 9.943 65.073 63.947 14.824-88.707m0 0 134.574 15.012-60.837 58.098 51.211 59.658-115.129 43.281 49.286 95.141m-59.105-271.19-108.776-30.22m108.969 342.352-108.969-30.414M41.646-148.57l33.5 109.568M65.519 78.754-74.253 34.693" />
    </g>
  </svg>
);

export default BgWireframePattern;
